import { DenovoIcon, Typography } from "@repo/design-system";

export function DataPageError() {
  return (
    <div className="flex min-h-[calc(100vh-6rem)] flex-col items-center justify-center gap-4 bg-backgroundPrimary">
      <DenovoIcon
        icon="alert"
        width={48}
        height={48}
        className="text-contentAlert"
      />
      <Typography variant="heading-4" className="text-contentPrimary">
        Failed to load data
      </Typography>
      <Typography
        variant="paragraph-l-regular"
        className="text-contentSecondary">
        Please check your connection and try again.
      </Typography>
    </div>
  );
}
